export default __webpack_public_path__ + "static/media/Group 160.86082e3f.png";